"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wordCase = exports.toCssVarFn = exports.toCssVar = exports.split = exports.snakeCase = exports.pascalCase = exports.kebabCase = exports.generateRandomId = exports.capitalize = exports.camelCase = void 0;
var _humps = require("humps");
const camelCase = str => (0, _humps.camelize)(str);
exports.camelCase = camelCase;
const pascalCase = str => (0, _humps.pascalize)(str);
exports.pascalCase = pascalCase;
const wordCase = str => (0, _humps.decamelize)(str, {
  separator: ' '
});
exports.wordCase = wordCase;
const kebabCase = str => (0, _humps.decamelize)(str, {
  separator: '-'
});
exports.kebabCase = kebabCase;
const snakeCase = str => (0, _humps.decamelize)(str, {
  separator: '_'
});
exports.snakeCase = snakeCase;
const toCssVar = str => {
  return `--${kebabCase(str)}`;
};
exports.toCssVar = toCssVar;
const split = (str, separator) => {
  return str.split(separator);
};
exports.split = split;
const toCssVarFn = str => {
  return `var(${toCssVar(str)})`;
};
exports.toCssVarFn = toCssVarFn;
const capitalize = str => {
  return str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
};
exports.capitalize = capitalize;
const generateRandomId = prefix => {
  return Math.random().toString(36).replace('0.', prefix !== null && prefix !== void 0 ? prefix : '');
};
exports.generateRandomId = generateRandomId;